angular.module("tromanWeb").controller("ErgoTableController", ['$scope', function ($scope) {

    var self = this;
    var stTableCtrl;
    var sourceGetter;

    self.selectionCount = 0;
    self.totalCount = 0;
    self.filteredCount = 0;

    var sourceCollection;
    var filteredCollection;

    function countSelected() {
        return Array.prototype.reduce.call(sourceCollection, function (a, v) {
            return a + (v.$$selected ? 1 : 0);
        }, 0);
    }

    self._init = function init(_stTableCtrl, source, selectionFilter) {
        sourceGetter = source;
        stTableCtrl = _stTableCtrl;

        var oldPipe = stTableCtrl.pipe;
        stTableCtrl.pipe = function () {
            oldPipe.apply(stTableCtrl, arguments);

            sourceCollection = sourceGetter($scope) || [];
            filteredCollection = stTableCtrl.getFilteredCollection() || [];
            if (selectionFilter) {
                sourceCollection = sourceCollection.filter(selectionFilter);
                filteredCollection = filteredCollection.filter(selectionFilter);
            }

            self.totalCount = sourceCollection.length;
            self.filteredCount = filteredCollection.length;
            self.selectionCount = countSelected();
        };
    };

    self._selectionChanged = function _selectionChanged(_item) {
        self.selectionCount = countSelected();
    };

    self.selectedItems = function selectedItems() {
        return Array.prototype.filter.call(sourceCollection, function (v) {
            return v.$$selected;
        });
    };

    self.selectFiltered = function selectFiltered(predicate) {
        if (predicate) {
            angular.forEach(filteredCollection, function (item) {
                let result = predicate(item);
                if (result === true || result === false) {
                    item.$$selected = result;
                }
            });
        } else {
            angular.forEach(filteredCollection, function (item) {
                item.$$selected = true;
            });
        }
        self.selectionCount = countSelected();
    };

    self.deselectAll = function deselectAll() {
        angular.forEach(sourceCollection, function (item) {
            item.$$selected = false;
        });
        self.selectionCount = 0;
    };

    self.search = function search(input, predicate, comparator) {
        stTableCtrl.search(input, predicate, comparator);
    };
}]);

angular.module("tromanWeb").directive("ergoTable", ['$parse', function ergoSelectDirective($parse) {

    return {
        restrict: "A",
        controller: "ErgoTableController",
        require: ["ergoTable", "stTable"],
        link: {
            pre: function (scope, _element, attributes, controllers) {
                var source = attributes.stSafeSrc || attributes.stTable;
                var ergoTableCtrl = controllers[0];
                var stTableCtrl = controllers[1];

                if (source && ergoTableCtrl && stTableCtrl) {
                    var getter = $parse(source);

                    var selectionFilter = null;
                    if (attributes.ergoSelectionFilter) {
                        var selectionFilterFn = $parse(attributes.ergoSelectionFilter);
                        selectionFilter = function (item) {
                            return selectionFilterFn(scope, { $item: item });
                        };
                    }

                    ergoTableCtrl._init(stTableCtrl, getter, selectionFilter);

                    var setter = attributes.ergoTable.length && $parse(attributes.ergoTable).assign;
                    if (setter) {
                        setter(scope, ergoTableCtrl);
                    }
                }
            }
        }
    };
}]);

angular.module("tromanWeb").directive("ergoCheckboxSelect", [function () {
    return {
        restrict: "A",
        require: ['ergoCheckbox', '?^ergoTable'],
        scope: {
            item: '<ergoCheckboxSelect'
        },
        link: function (scope, _element, _attributes, ctrls) {

            var ergoCheckbox = ctrls[0];
            var ergoTableCtrl = ctrls[1];

            ergoCheckbox.register('select', function () {
                scope.$evalAsync(() => {
                    if (scope.item) {
                        scope.item.$$selected = ergoCheckbox.value;
                        if (ergoTableCtrl) {
                            ergoTableCtrl._selectionChanged(scope.item);
                        }
                    }
                });
            });

            scope.$watch('item.$$selected', function (val) {
                ergoCheckbox.update('select', val);
            });
        }
    };
}]);